import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const itTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nome (minuscolo, senza caratteri speciali)',
    add: 'Aggiungi',
    allowedFileTypes: 'Tipi di file consentiti',
    allowedFileTypesDescription:
      'Limita i tipi di file consentiti (ad esempio immagine/*, applicazione/pdf). Lascia vuoto per consentire tutti i tipi.',
    allowMultipleFiles: 'Consenti più file',
    amountInCents: 'Importo in centesimi',
    basePrice: 'Prezzo base',
    bcc: 'BCC',
    brand: 'Marchio',
    cc: 'CC',
    checkboxPlural: 'Campi casella di controllo',
    checkboxSingular: 'Casella di controllo',
    checkedByDefault: 'Selezionato per impostazione predefinita',
    chooseConfirmationType:
      'Scegli se visualizzare un messaggio sulla pagina o reindirizzare a una pagina diversa dopo aver inviato il modulo.',
    condition: 'Condizione',
    confirmationMessage: 'Messaggio di conferma',
    confirmationType: 'Tipo di conferma',
    countryPlural: 'Campi di campagna',
    countrySingular: 'Paese',
    creditCard: 'Carta di credito',
    customURL: 'URL personalizzato',
    datePlural: 'Campi data',
    dateSingular: 'Data',
    defaultValue: 'Valore predefinito',
    divide: 'Dividere',
    documentToLinkTo: 'Documento a cui collegarsi',
    doesNotEqual: 'Non è uguale',
    emailFrom: 'E-mail da',
    emailPlural: 'Campi e-mail',
    emailsDescription:
      "Invia email personalizzate quando il modulo viene inviato. Utilizza elenchi separati da virgole per inviare la stessa email a più destinatari. Per fare riferimento a un valore da questo modulo, racchiudi il nome del campo tra doppie parentesi graffe, ad esempio {{firstName}}. Puoi utilizzare un carattere jolly {{*}} per visualizzare tutti i dati e {{*:table}} per formattarlo come tabella HTML nell'e-mail.",
    emailSingular: 'E-mail',
    emailTo: "Invia un'e-mail a",
    equals: 'Uguali',
    field: 'Campo',
    fields: 'Campi',
    fieldWidth: 'Larghezza del campo (percentuale)',
    hasAnyValue: 'Ha qualsiasi valore',
    internalLink: 'Collegamento interno',
    label: 'Etichetta',
    maxFileSize: 'Dimensione massima file (byte)',
    maxFileSizeDescription: 'Dimensione massima del file in byte. Lascia vuoto per nessun limite.',
    message: 'Messaggio',
    messageDescription: 'Inserisci il messaggio che deve essere inviato in questa email.',
    messagePlural: 'Blocchi di messaggi',
    messageSingular: 'Messaggio',
    mimeType: 'Tipo MIME',
    mimeTypePlural: 'Tipi MIME',
    mimeTypeSingular: 'Tipo MIME',
    multiply: 'Moltiplicare',
    numberPlural: 'Campi numerici',
    numberSingular: 'Numero',
    optionPlural: 'Opzioni',
    optionSingular: 'Opzione',
    paymentFieldPlural: 'Campi di pagamento',
    paymentFieldSingular: 'Pagamento',
    paymentProcessor: 'Processore di pagamento',
    paymentStatus: 'Stato',
    placeholder: 'Segnaposto',
    priceConditions: 'Condizioni di prezzo',
    priceConditionsPlural: 'Condizioni di prezzo',
    priceConditionsSingular: 'Condizione del prezzo',
    radioOptions: 'Opzioni degli attributi radio',
    radioPlural: 'Campi radiofonici',
    radioSingular: 'Radio',
    redirect: 'Reindirizzamento',
    replyTo: 'Rispondi a',
    required: 'Obbligatorio',
    selectOptions: 'Seleziona Opzioni',
    selectPlural: 'Seleziona Campi',
    selectSingular: 'Seleziona',
    statePlural: 'Campi statali',
    stateSingular: 'Stato',
    staticValue: 'Valore statico',
    subject: 'Oggetto',
    submitButton: 'Invia etichetta pulsante',
    subtract: 'Sottrarre',
    textareaPlural: "Campi dell'area di testo",
    textareaSingular: 'Area di testo',
    textPlural: 'Campi di testo',
    textSingular: 'Testo',
    title: 'Titolo',
    token: 'gettone',
    uploadCollection: 'Carica raccolta',
    uploadCollectionDescription: 'Seleziona in quale raccolta di caricamento archiviare i file',
    uploadFieldPlural: 'Carica campi',
    uploadFieldSingular: 'Carica',
    urlToRedirectTo: 'URL a cui reindirizzare',
    value: 'Valore',
    valueOfField: 'Valore del campo',
    valueType: 'Tipo di valore',
  },
}

export const it: PluginLanguage = {
  dateFNSKey: 'it',
  translations: itTranslations,
}
